import React from 'react';
import propTypes from 'prop-types';
import { UiSelectAdapter } from '../logic';
import { UiSelect } from '../ui-kit';

export function AddressPicker({ onChange, label, meta, value, ...rest }) {
  if (!(window.google && window.google.maps)) {
    return null;
  }
  const { places, Geocoder, GeocoderStatus } = window.google.maps;
  const { PlacesServiceStatus, AutocompleteService } = places;

  const onAutoSuggestComplete = callback => (predictions, status) => {
    if (status === PlacesServiceStatus.OK) {
      callback(
        predictions.map(p => ({ key: p.place_id, label: p.description }))
      );
    } else {
      callback([]);
    }
  };

  const fetchAddresses = (searchText, callback) => {
    if (searchText) {
      const autocompleteService = new AutocompleteService();

      autocompleteService.getPlacePredictions(
        { input: searchText },
        onAutoSuggestComplete(callback)
      );
    }
  };

  const parsePlacesResult = (data, place) => {
    const address = { ...place };

    data.address_components.forEach(ac => {
      if (ac.types.includes('street_number')) {
        address.streetNumber = ac.long_name;
      }
      if (ac.types.includes('route')) {
        address.street = ac.long_name;
      }
      if (ac.types.includes('locality')) {
        address.city = ac.long_name;
      }
      if (ac.types.includes('administrative_area_level_2')) {
        address.county = ac.long_name;
      }
      if (ac.types.includes('administrative_area_level_1')) {
        address.state = ac.short_name;
      }
      if (ac.types.includes('country')) {
        address.country = ac.short_name;
      }
      if (ac.types.includes('postal_code')) {
        address.zipCode = ac.short_name;
      }
    });

    address.address = address.streetNumber || '';
    if (address.street && address.streetNumber) {
      address.address += ' ';
    }
    address.address += address.street || '';

    return address;
  };

  const getAddressDetails = place => {
    const geocoder = new Geocoder();

    geocoder.geocode({ placeId: place.key }, (places, status) => {
      if (status === GeocoderStatus.OK && onChange) {
        onChange(parsePlacesResult(places[0], place));
      }
    });
  };

  const clear = () => {
    if (onChange) {
      onChange('');
    }
  };

  const SelectComponent = meta ? UiSelectAdapter : UiSelect;

  return (
    <SelectComponent
      label={label}
      defaultOptions={[]}
      components={{ DropdownIndicator: null }}
      isClearable
      noOptionsMessage={() => 'Start typing to load addresses'}
      meta={meta}
      getOptionValue={item => item.key}
      value={value}
      {...rest}
      cacheOptions
      loadOptions={fetchAddresses}
      onChange={item => (item ? getAddressDetails(item) : clear())}
    />
  );
}

AddressPicker.defaultProps = {
  meta: null,
};

AddressPicker.propTypes = {
  label: propTypes.string.isRequired,
  value: propTypes.oneOfType([propTypes.string, propTypes.object]).isRequired,
  onChange: propTypes.func.isRequired,
  meta: propTypes.object,
};
